<template>
  <!-- <i-override-dialog
    :modal="true"
    :dismissableMask="true"
    :title="__('Payment for car charging')"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 40px)',
    }"
    :close="close"
    v-model:visible="showModal"
  > -->
  <div class="p-p-4" v-if="meter">
    <div class="p-mb-3">{{ __('Counter number') }}: {{ meter.MeterNum }}</div>
    <div class="p-my-3">
      {{ __('Last meter reading') }}:
      {{ IsEdit ? meter.PrevReadingCount : meter.ReadCount }}
      <!-- {{
        meter.ReadDate
          ? __("on the date") + " " + dateFormat(new Date(meter.ReadDate))
          : ""
      }} -->
    </div>
    <div class="p-my-3">
      {{ __('Price per kWh') }}:
      {{
        __u_value__({
          value: meter.kWhPrice,
          unit: 'P-NIS',
          Digits: 2,
        })
      }}
    </div>

    <div class="p-d-flex p-flex-column p-mt-2">
      <label>{{ __('Current meter reading') }}:</label>
      <div class="p-d-flex p-flex-column p-ai-center p-my-4">
        <div>
          <div class="picker">
            <i-smooth-picker
              v-if="modifierArray.length > 0"
              :data="modifierArray"
              :in-screen="3"
              v-model="modifier"
            />

            <span class="separator">.</span>
            <i-smooth-picker
              v-if="wholeNumberArray.length > 0"
              :data="wholeNumberArray"
              :in-screen="3"
              v-model="wholeNumber"
            />
          </div>
        </div>
        <div class="p-d-flex p-ai-center p-jc-center p-my-2">
          <p-vue-button
            class="p-button-rounded p-button-outlined"
            label="+ 10"
            @click="wholeNumber = wholeNumber + 10"
          />
          <p-vue-button
            class="p-mr-3 p-button-rounded p-button-outlined"
            label="+ 100"
            @click="wholeNumber = wholeNumber + 100"
          />
        </div>
      </div>
      <div class="p-mb-2 p-d-flex p-jc-center">
        <p-vue-input-text
          v-model="newReadCountText"
          @blur="updatenewReadCount"
        />
      </div>
      <i-form-error :data="errors.NewReadCount" />
    </div>
    <div class="p-d-flex p-jc-center">
      <div>
        {{ __('Total consumption') }}:
        {{
          __u_value__({
            value: IsEdit
              ? this.NewReadCount - this.meter.PrevReadingCount
              : this.NewReadCount - this.meter.ReadCount,
            unit: 'number-f',
          })
        }}
      </div>
    </div>
    <div class="upload-button p-mt-4" @click="addImage">
      <span class="p-button-icon p-button-icon-left pi pi-fw pi-plus"></span>
      {{ __('Add an image') }}
    </div>
    <i-form-error :data="errors.attachments" />
    <p-vue-file-upload
      url="./"
      accept="image/*"
      class="upload-button"
      style="display: none"
      :multiple="false"
      :customUpload="true"
      :showCancelButton="false"
      :showUploadButton="false"
      :chooseLabel="__('Add an image')"
      :invalidFileLimitMessage="
        __('Maximum number of files exceeded, limit is {0} at most.')
      "
      :invalidFileSizeMessage="
        __('{0}: Invalid file size, file size should be smaller than {1}.')
      "
      v-model="attachments"
      ref="Upload"
    />
    <div class="upload-preview">
      <ul>
        <li v-for="(file, index) in attachments" :key="index">
          <img :src="file" />
          <p-vue-button
            class="p-button-danger p-button-sm p-button-rounded"
            @click.prevent="doTrashAttachment(index)"
          >
            <i-icon name="trash" />
          </p-vue-button>
        </li>
      </ul>
    </div>
    <div class="p-d-flex p-jc-between p-mt-4">
      <p-vue-button
        :class="{
          submit: true,
          'p-button': true,
          'p-button-lg': true,
          'p-button-success': true,
          'p-button-rounded': true,
        }"
        @click="$router.go(-1)"
        :loading="btnLoading"
        icon
        :label="__('Cancel')"
      >
      </p-vue-button>
      <p-vue-button
        :class="{
          submit: true,
          'p-button': true,
          'p-button-lg': true,
          'p-button-success': true,
          'p-button-rounded': true,
        }"
        @click="submit"
        :loading="btnLoading"
        icon
        :label="__('Save')"
      >
      </p-vue-button>
    </div>
  </div>
  <!-- </i-override-dialog> -->
  <p-get-image v-if="getImage" @getImage="getPictureLocal"></p-get-image>
</template>

<script>
import { callProc, apiParam, apiPType } from '@/services/APointAPI'
import { errorReceived, showSuccessOrFailedModal } from '@/services/apointUtil'
import { __ } from '@/plugins/i18n/index'
import { getPicture } from '../../services/UploadFilesService'
// import { uploadB64 } from "../../services/APointAPI";
import { App_FileCreate } from '../../services/cloudflareUploaderService'
import PGetImage from '@/components/partials/p-get-image'
import { ValidationError } from 'vue3-form-validation'
// import { dateFormat } from "../../services/apointUtil";

export default {
  plugins: { __ },
  components: {
    PGetImage,
  },
  data() {
    return {
      showModal: true,
      meterID: this.$route.params.meterid,
      BID: this.$route.params.bid,
      meter: {},
      attachments: [],
      getImage: false,
      readID: null,
      btnLoading: false,
      // dateFormat,
      errors: {},
      wholeNumber: null,
      modifier: null,
      wholeNumberArray: [],
      modifierArray: [],
      newReadCountText: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let procParams = [apiParam('MeterID', this.meterID, apiPType.Int)]
      callProc('WorkerApp_GetMeterDataByMeterID', procParams)
        .then((result) => {
          result = JSON.parse(result)
          this.meter = result.Table[0]

          if (this.meter) {
            this.splitDecimal(this.meter.ReadCount)
            this.newReadCountText = this.NewReadCount
          }
        })
        .catch((error) => {
          errorReceived(
            'WorkerApp_GetMeterDataByMeterID',
            error,
            __('An error occurred')
          )
        })
    },
    addImage() {
      this.getImage = false
      setTimeout(() => {
        this.getImage = true
      }, 0)
    },
    getPictureLocal(sourceType) {
      getPicture(sourceType, (obj) => {
        this.getImage = false
        this.attachments[0] = obj
      })
    },
    validateFields() {
      this.valid = true
      this.errors = {}
      // if (!this.attachments || this.attachments.length == 0) {
      //   this.valid = false;
      //   this.errors.attachments = __("Please attach a photo of the meter");
      // }
      if (!this.NewReadCount) {
        this.valid = false
        this.errors.NewReadCount = __('Required field')
      } else if (!(this.NewReadCount > this.meter.ReadCount)) {
        this.valid = false
        this.errors.NewReadCount = __(
          'Current meter reading should be greater than previous reading'
        )
      }
    },
    submit() {
      if (this.IsEdit) {
        this.saveEditReading()
        return
      }
      try {
        this.validateFields()
        if (this.valid) {
          this.btnLoading = true
          let procParams = [
            apiParam('ReadCount', this.NewReadCount, apiPType.VarChar),
            apiParam('MeterNum', this.meter.MeterNum, apiPType.NVarChar),
            apiParam('UID', this.meter.UID, apiPType.Int),
            apiParam('MeterID', this.meter.MeterID, apiPType.Int),
          ]
          callProc('WorkerApp_AddMeterReadingAndUpdateMeter', procParams)
            .then((result) => {
              result = JSON.parse(result)
              if (result.Table) {
                this.readID = result.Table[0].readID
                if (this.attachments.length > 0)
                  this.upload(
                    this.attachments[0],
                    this.meter.MeterNum + '.jpeg'
                  )
                else {
                  this.$store.dispatch('doLoading', false)
                  showSuccessOrFailedModal(
                    __('The meter reading was saved successfully')
                  )
                  this.close()
                }
              } else {
                showSuccessOrFailedModal(
                  __('Error saving reading'),
                  2000,
                  false
                )
                this.btnLoading = false
              }
            })
            .catch((error) => {
              errorReceived(
                'WorkerApp_AddMeterReadingAndUpdateMeter',
                error,
                __('An error occurred')
              )
              this.btnLoading = false
            })
        }
      } catch (err) {
        if (!(err instanceof ValidationError)) console.error(err)
      }
    },
    upload(file, srcFileName) {
      App_FileCreate(14, this.readID, srcFileName, file)
        .then((response) => {
          this.$store.dispatch('doLoading', false)
          // console.log("App_FileCreate", response);
          this.btnLoading = false
          if (response === true) {
            this.$store.dispatch('doLoading', false)
            showSuccessOrFailedModal(
              __('The meter reading was saved successfully')
            )
            this.close()
          } else {
            showSuccessOrFailedModal(__('Error saving reading'), false)
            this.close()
          }
        })
        .catch((e) => {
          console.log(e)
          this.btnLoading = false
          this.uploadProgress = 0
        })
    },
    close() {
      this.$router.push({
        name: 'ElectricityMeter',
        params: {
          bid: this.BID,
        },
      })
    },
    splitDecimal(num) {
      this.wholeNumber = Math.floor(num)
      var decimalPart = num - this.wholeNumber
      this.modifier = Math.round(decimalPart * 100)

      this.wholeNumberArray = Array.from({ length: 1001 }, (_, index) => ({
        value: index + this.wholeNumber,
        label: index + this.wholeNumber,
      }))

      this.modifierArray = [...Array(100).keys()].map((v, i) => ({
        value: i,
        label: i,
      }))
    },
    doTrashAttachment(index) {
      this.attachments.splice(index, 1)
    },
    updatenewReadCount() {
      if (isNaN(this.newReadCountText)) {
        this.newReadCountText = this.NewReadCount
        errorReceived(__('Set correctly number'), null, __('An error occurred'))
      } else {
        this.splitDecimal(this.newReadCountText)
      }
    },
    saveEditReading() {
      try {
        this.validateFields()
        if (this.valid) {
          this.btnLoading = true
          let procParams = [
            apiParam('ReadCount', this.NewReadCount, apiPType.VarChar),
            apiParam('MeterReadingId', this.meter.MRID, apiPType.NVarChar),
          ]
          callProc('WorkerApp_EditMeterReading', procParams)
            .then((result) => {
              result = JSON.parse(result)
              if (result.procReturnValue == 0) {
                this.readID = this.meter.MRID
                if (this.attachments.length > 0)
                  this.upload(
                    this.attachments[0],
                    this.meter.MeterNum + '.jpeg'
                  )
                else {
                  this.$store.dispatch('doLoading', false)
                  showSuccessOrFailedModal(
                    __('The meter reading was saved successfully')
                  )
                  this.close()
                }
              } else {
                let msg = 'An error occurred while deleting the reading'
                switch (result.procReturnValue) {
                  case 2:
                    msg =
                      'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made'
                    break
                  case 3:
                    msg = 'Only the last meter reading can be deleted'
                    break
                  default:
                    msg = 'An error occurred while deleting the reading'
                    break
                }
                showSuccessOrFailedModal(__(msg), false, 5000)
                this.btnLoading = false
              }
            })
            .catch((error) => {
              errorReceived(
                'WorkerApp_EditMeterReading',
                error,
                __('An error occurred')
              )
              this.btnLoading = false
            })
        }
      } catch (err) {
        if (!(err instanceof ValidationError)) console.error(err)
      }
    },
    checkEditReturnValue() {},
  },
  computed: {
    sum() {
      if (this.meter && this.NewReadCount)
        return this.totalConsumption * this.meter.kWhPrice
      return 0
    },
    commitionSum() {
      if (this.sum > 0)
        return this.sum * this.commision.comm_base + this.commision.comm_action
      return 0
    },
    totalConsumption() {
      return this.NewReadCount - this.meter.ReadCount
    },
    NewReadCount() {
      return this.wholeNumber + this.modifier / 100
    },
    IsEdit() {
      return this.$route.name == 'EditReport'
    },
  },
  watch: {
    wholeNumber() {
      let lastVal = this.wholeNumberArray[this.wholeNumberArray.length - 1]
        .value
      if (this.wholeNumber + 1000 > lastVal) {
        for (
          let index = lastVal + 1;
          index < this.wholeNumber + 1000;
          index++
        ) {
          this.wholeNumberArray.push({
            value: index,
            label: index,
          })
        }
      }
    },
    NewReadCount() {
      // console.log(this.NewReadCount);
      this.newReadCountText = this.NewReadCount
    },
  },
}
</script>

<style scoped>
.upload-button {
  margin-top: 25px;
  display: block;
  width: 100%;
  margin: 0;
  padding: 13px 15px;
  border-radius: 30px;
  background-color: white;
  border: 1px solid var(--color-success);
  color: black;
  font-size: 16px;
  line-height: 1.28;
  letter-spacing: 0.51px;
  text-align: center;
}

.upload-button:deep(.p-button) {
  display: block;

  width: 100%;

  margin: 0;
  padding: 13px 15px;

  border-radius: 30px;
  background-color: white;
  border: 1px solid var(--color-success);

  color: black;
  font-size: 16px;
  line-height: 1.28;
  letter-spacing: 0.51px;
}

.newReadCount {
  display: grid;
  grid-template-columns: 3rem 40% 21%;
  align-items: center;
  justify-content: space-between;
}

.upload-preview ul {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

  margin: 0;
  padding: 15px 0 0 0;

  list-style: none;
}

.upload-preview ul li {
  /* position: relative; */
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 150px;
}

.upload-preview ul li img {
  /* width: 100%; */
  height: 100%;

  object-fit: cover;
}

.upload-preview ul li:deep(.svg) {
  width: 15px;
  height: 15px;
}

.upload-preview ul li:deep(.p-button) {
  /* top: -5px;
  left: -5px;
  z-index: 2;
  position: absolute; */

  padding: 3px;
}

.picker {
  direction: rtl;
  display: grid;
  align-items: center;
  grid-template-columns: auto auto auto;
}

.separator {
  font-size: 16px;
  color: #ababab;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.p-inputtext {
  text-align: center;
}
</style>
